import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomConfirmDialogService } from 'src/app/services/Non-Master/CustomConfirmDialog.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { tPackageService } from 'src/app/services/tPackage.service';
import { tPackageModel } from 'src/app/models/tPackageModel';
import { SpecialPaymentMethod } from 'src/app/models/non-master-model/SpecialPaymentMethod';
import { tBillPayModel, BillPay_ItemType, BillPay_Patient_PackageModel, PatientRelative_PackageModel } from 'src/app/models/tBillPayModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { MatTableDataSource, MatSort } from '@angular/material';
import { AppComponent } from 'src/app/app.component';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tBillPayService } from 'src/app/services/tBillPay.service';
import { BillPayPayment_PackageToalAmount_InputValueDialogService } from 'src/app/services/Non-Master/BillPayPayment_Package_totalAmount_InputValueDialog.service';

@Component({
  selector: 'app-bill-payment-package-total-amount',
  templateUrl: './bill-payment-package-total-amount.component.html',
  styleUrls: ['./bill-payment-package-total-amount.component.css']
})
export class BillPaymentPackageTotalAmountComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private tBillPayService: tBillPayService,
    private dateTimeConvertService: DateTimeConvertService,
    private apiResultHandlerService: ApiResultHandlerService,
    private billPayPayment_PackageToalAmount_InputValueDialogService: BillPayPayment_PackageToalAmount_InputValueDialogService

  ) { }

  private TAG = "BillPaymentPackageTotalAmountComponent";

  ngOnInit() {
    // this.setDefaultLanguageString(AppComponent.usingLanguage);
    this.getAllData();
  }

  dataSource: MatTableDataSource<BillPay_Patient_PackageModel>;
  dataList: BillPay_Patient_PackageModel[];
  @ViewChild(MatSort) sort: MatSort;


  @Input() patientID: string;
  @Input() invoiceID: string;
  @Input() orgArAmount: number;
  @Input() isChangePay?: boolean;
  @Input() invoiceChangeID?: string;


  // @Input() selectedBillPayModel: tBillPayModel;


  //loading spinner
  isLoading = true;



  displayedColumns: string[] = [
    'cPackageID',
    'packDescAll',
    'expirationDate',

    'packageRemaining',
    'patientName'

  ];




  getAllData() {

    this.getPatientPackage();

    this.log.i(this.TAG," orgArAmount = "+this.orgArAmount);
  }


  getPatientPackage(): void {
    this.log.i(this.TAG, ' getPatientPackage patientID = ' + this.patientID);

    this.tBillPayService.getPatientPacket_TotalAmountPackageOnly(this.patientID).subscribe(data => {


      var allPatientRelative_PackageModel: PatientRelative_PackageModel = data;

      // console.table(data);

      var allPackage: BillPay_Patient_PackageModel[] = new Array;

      if (allPatientRelative_PackageModel.selfpackage != null) {
        for (var p = 0; p < allPatientRelative_PackageModel.selfpackage.length; p++) {
          allPackage.push(allPatientRelative_PackageModel.selfpackage[p]);
        }
      }

      if (allPatientRelative_PackageModel.otherPatientPackage != null) {
        for (var p = 0; p < allPatientRelative_PackageModel.otherPatientPackage.length; p++) {
          allPackage.push(allPatientRelative_PackageModel.otherPatientPackage[p]);
        }
      }

      if (allPatientRelative_PackageModel.selfPrepay != null) {
        for (var p = 0; p < allPatientRelative_PackageModel.selfPrepay.length; p++) {
          allPackage.push(allPatientRelative_PackageModel.selfPrepay[p]);
        }
      }

      if (allPatientRelative_PackageModel.otherPatientPrepay != null) {
        for (var p = 0; p < allPatientRelative_PackageModel.otherPatientPrepay.length; p++) {
          allPackage.push(allPatientRelative_PackageModel.otherPatientPrepay[p]);
        }
      }


      // this.dataSource = new MatTableDataSource<BillPay_Patient_PackageModel>(data);
      // this.dataList = data;

      this.dataSource = new MatTableDataSource<BillPay_Patient_PackageModel>(allPackage);
      this.dataList = allPackage;

      this.log.i(this.TAG,"allPackage length = "+allPackage.length+ "getPatientPacket data = " + JSON.stringify(data));

      //loading spinner
      this.isLoading = false;
      //table sort
      this.dataSource.sort = this.sort;

    },
      error => this.isLoading = false);
  }

  // setDefaultLanguageString(language: String) {

  // }


  formatDate(date: string) {
    const newDate = new Date(date);
    return this.dateTimeConvertService.ConvertCurrentDay(newDate);
  }

  selectedPackageRecord(selectedModel: BillPay_Patient_PackageModel) {

    this.log.i(this.TAG, "invoiceID = " + this.invoiceID);
    // grouup the data and send to server
    var shopID: string = NavigationComponent.selectedShopID.toString();
    var bpInvoiceNumber: string = this.invoiceID;
    var bpLineNumber: number = 1;
    var bpPaymentNumber: string = SpecialPaymentMethod.Package.toString();
    var bpDateTime: Date = null;
    var bpPatientID: string = selectedModel.billPay.bpPatientID;
    var bpChangeID: string = null;
    var bpConsultNumber: string = null;
    var bpItemID: string = null;
    var bpItemType: string = BillPay_ItemType.PAYMENT;
    var bpItemDesc: string = null;
    var bpQty: number = null;
    var bpStandardPrice: number = null;

    var bpFinalPrice: number = null;
    var bpLineAmount: number = null;
    // var packItemID : string = selectedModel.packageInfo.packItemID;

    var bpArAmount: number = null;

    var bpPackInvoiceNo: string = selectedModel.billPay.bpPackInvoiceNo;
    var bpPackItemID: string = selectedModel.packageInfo.packItemID;
    var bpPackageQty: number = null;
    var bpPackFaceAmt: number = null;
    var bpPackID: string = selectedModel.packageInfo.packID;
    console.log("bpPackID = " + bpPackID);
    var bpPaymentMethodName: string = selectedModel.packageInfo.packDesc;
    var bpRemark: string = null;
    var bpPaymentRemark: string = null;

    var inActive: string = "N";
    var lastModifyDatetime: Date = null;
    var lastModifyUserID: string = NavigationComponent.userID;



    var bpEmployeeID: string = null;
    var bpPrintName: string = null;
    var bpPaymentMethodID: string = SpecialPaymentMethod.Package.toString();

    var paymentName: string = null;



    var newBillPay = new tBillPayModel();
    newBillPay.shopID = shopID;
    newBillPay.bpInvoiceNumber = bpInvoiceNumber;
    newBillPay.bpLineNumber = bpLineNumber;
    newBillPay.bpPaymentNumber = bpPaymentNumber;
    newBillPay.bpDateTime = bpDateTime;
    newBillPay.bpPatientID = bpPatientID;
    newBillPay.bpChangeID = bpChangeID;
    newBillPay.bpConsultNumber = bpConsultNumber;
    newBillPay.bpItemID = bpItemID;
    newBillPay.bpItemType = bpItemType;
    newBillPay.bpItemDesc = bpItemDesc;
    newBillPay.bpQty = bpQty;
    newBillPay.bpStandardPrice = bpStandardPrice;
    newBillPay.bpFinalPrice = bpFinalPrice;
    newBillPay.bpLineAmount = bpLineAmount;
    newBillPay.bpArAmount = bpArAmount;
    newBillPay.bpPackInvoiceNo = bpPackInvoiceNo;
    newBillPay.bpPackItemID = bpPackItemID;
    newBillPay.bpPackageQty = bpPackageQty;
    newBillPay.bpPackFaceAmt = bpPackFaceAmt;

    newBillPay.bpPackID = bpPackID;
    newBillPay.bpItemID = bpItemID;

    newBillPay.bpEmployeeID = bpEmployeeID;
    newBillPay.bpPrintName = bpPrintName;
    newBillPay.bpPaymentMethodID = bpPaymentMethodID;
    newBillPay.bpPaymentMethodName = bpPaymentMethodName;
    newBillPay.bpRemark = bpRemark;
    newBillPay.bpPaymentRemark = bpPaymentRemark;
    newBillPay.inActive = inActive;
    newBillPay.lastModifyDatetime = lastModifyDatetime;
    newBillPay.lastModifyUserID = lastModifyUserID;

    this.log.i(this.TAG, " newBillPay = " + JSON.stringify(newBillPay) );

    if(this.isChangePay){
      newBillPay.bpChangeID = this.invoiceChangeID;
      // console.table(selectedModel.billPay);
    }

    this.billPayPayment_PackageToalAmount_InputValueDialogService.openDialog(newBillPay, selectedModel,this.orgArAmount,this.isChangePay).result.then((result) => {

      //  this.log.i(this.TAG, "close payment result = " + result);
      this.activeModal.close(result);

    }, (reason) => {
      this.log.w(this.TAG, "billPayment reason = " + reason);
    });



  }


}
